import React from 'react';
import { Section } from './ui/Section';
export function PainSection() {
  return <Section alternate data-id="element-117">
      <div className="space-y-8" data-id="element-118">
        <h2 className="text-3xl md:text-4xl font-serif text-cream-50 mb-6" data-id="element-119">
          Si te despiertas sudando… <br data-id="element-120" />
          <span className="text-amber-500" data-id="element-121">esto es para ti</span>
        </h2>

        <div className="space-y-6 text-lg md:text-xl text-cream-100 leading-relaxed" data-id="element-122">
          <p data-id="element-123">No voy a venderte perfección.</p>
          <p data-id="element-124">Ni voy a prometer que "nunca más" vas a despertarte.</p>
          <p data-id="element-125">Voy a darte algo más útil a tu edad:</p>
          <p className="font-bold text-cream-50" data-id="element-126">
            Un protocolo claro para cuando pase.
          </p>
          <p data-id="element-127">
            Porque en la vida real, lo que te destruye no es el primer
            despertar.
          </p>
          <p data-id="element-128">Es lo que viene después:</p>

          <ul className="space-y-4 my-6 pl-4 border-l-2 border-warm-700" data-id="element-129">
            <li className="flex items-start" data-id="element-130">
              <span className="text-amber-500 mr-3 text-xl" data-id="element-131">•</span>
              <span data-id="element-132">miras la hora (y ya te arruinaste)</span>
            </li>
            <li className="flex items-start" data-id="element-133">
              <span className="text-amber-500 mr-3 text-xl" data-id="element-134">•</span>
              <span data-id="element-135">te enojas ("mañana estaré fatal")</span>
            </li>
            <li className="flex items-start" data-id="element-136">
              <span className="text-amber-500 mr-3 text-xl" data-id="element-137">•</span>
              <span data-id="element-138">empiezas a pensar en todo</span>
            </li>
            <li className="flex items-start" data-id="element-139">
              <span className="text-amber-500 mr-3 text-xl" data-id="element-140">•</span>
              <span className="font-medium text-cream-50" data-id="element-141">
                y de pronto estás despierta… despierta de verdad
              </span>
            </li>
          </ul>

          <div className="bg-warm-900 p-6 rounded-lg border border-warm-700 shadow-lg mt-8" data-id="element-142">
            <p className="text-xl font-serif italic text-amber-500 mb-2" data-id="element-143">
              El Segundo Golpe
            </p>
            <p data-id="element-144">
              A eso yo le llamo el "segundo golpe". Y si cortas el segundo
              golpe, el episodio deja de convertirse en insomnio.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}